import { HttpClient } from '@angular/common/http';
import {
  ModuleWithProviders,
  NgModule,
  Optional,
  SkipSelf,
} from '@angular/core';
import { Configuration } from './configuration';

import { AdditionalDocsExternalService } from './api/additionalDocsExternal.service';
import { AnnouncementCaseService } from './api/announcementCase.service';
import { AnnouncementCaseExternalService } from './api/announcementCaseExternal.service';
import { AuthoritySettingService } from './api/authoritySetting.service';
import { AuthoritySettingExternalService } from './api/authoritySettingExternal.service';
import { BusinessApiTraceLogService } from './api/businessApiTraceLog.service';
import { BusinessGroupSettingService } from './api/businessGroupSetting.service';
import { BusinessMessageTraceLogService } from './api/businessMessageTraceLog.service';
import { CodeTableService } from './api/codeTable.service';
import { CoreExternalService } from './api/coreExternal.service';
import { CounselorSettingService } from './api/counselorSetting.service';
import { CustAuditPermSettingExternalService } from './api/custAuditPermSettingExternal.service';
import { CustAuditPermitSettingService } from './api/custAuditPermitSetting.service';
import { CustReviewExplainExternalService } from './api/custReviewExplainExternal.service';
import { CustReviewPermissionService } from './api/custReviewPermission.service';
import { CustReviewPermissionExternalService } from './api/custReviewPermissionExternal.service';
import { CustomerServiceGroupSettingService } from './api/customerServiceGroupSetting.service';
import { CustomerServiceGroupSettingExternalService } from './api/customerServiceGroupSettingExternal.service';
import { CustomerServiceMappingSettingService } from './api/customerServiceMappingSetting.service';
import { CustomerServiceMappingSettingExternalService } from './api/customerServiceMappingSettingExternal.service';
import { MaskingService } from './api/masking.service';
import { MessageResendService } from './api/messageResend.service';
import { NotificationLogExternalService } from './api/notificationLogExternal.service';
import { PersonalDataColumnService } from './api/personalDataColumn.service';
import { PersonalDataSearchLogService } from './api/personalDataSearchLog.service';
import { ReviewPermissionDealerService } from './api/reviewPermissionDealer.service';
import { ReviewPermissionDealerExternalService } from './api/reviewPermissionDealerExternal.service';
import { RuleEngineService } from './api/ruleEngine.service';
import { ScheduleService } from './api/schedule.service';
import { ScheduleExternalService } from './api/scheduleExternal.service';
import { ScoringSettingService } from './api/scoringSetting.service';
import { SystemParameterService } from './api/systemParameter.service';
import { UserBusinessRegionSettingService } from './api/userBusinessRegionSetting.service';

@NgModule({
  imports: [],
  declarations: [],
  exports: [],
  providers: [
    AdditionalDocsExternalService,
    AnnouncementCaseService,
    AnnouncementCaseExternalService,
    AuthoritySettingService,
    AuthoritySettingExternalService,
    BusinessApiTraceLogService,
    BusinessGroupSettingService,
    BusinessMessageTraceLogService,
    CodeTableService,
    CoreExternalService,
    CounselorSettingService,
    CustAuditPermSettingExternalService,
    CustAuditPermitSettingService,
    CustReviewExplainExternalService,
    CustReviewPermissionService,
    CustReviewPermissionExternalService,
    CustomerServiceGroupSettingService,
    CustomerServiceGroupSettingExternalService,
    CustomerServiceMappingSettingService,
    CustomerServiceMappingSettingExternalService,
    MaskingService,
    MessageResendService,
    NotificationLogExternalService,
    PersonalDataColumnService,
    PersonalDataSearchLogService,
    ReviewPermissionDealerService,
    ReviewPermissionDealerExternalService,
    RuleEngineService,
    ScheduleService,
    ScheduleExternalService,
    ScoringSettingService,
    SystemParameterService,
    UserBusinessRegionSettingService,
  ],
})
export class ApiModule {
  public static forRoot(
    configurationFactory: () => Configuration
  ): ModuleWithProviders<ApiModule> {
    return {
      ngModule: ApiModule,
      providers: [{ provide: Configuration, useFactory: configurationFactory }],
    };
  }

  constructor(
    @Optional() @SkipSelf() parentModule: ApiModule,
    @Optional() http: HttpClient
  ) {
    if (parentModule) {
      throw new Error(
        'ApiModule is already loaded. Import in your base AppModule only.'
      );
    }
    if (!http) {
      throw new Error(
        'You need to import the HttpClientModule in your AppModule! \n' +
          'See also https://github.com/angular/angular/issues/20575'
      );
    }
  }
}
